export const CHANGE_LANGUAJE = "CHANGE_LANGUAJE";
export const MAP_INITIAL_DATA = "MAP_INITIAL_DATA";
export const OPEN_MODAL_VIDEO = "OPEN_MODAL_VIDEO";
export const CLOSE_MODAL_VIDEO = "CLOSE_MODAL_VIDEO";
export const OPEN_DIALOG = "OPEN_DIALOG";
export const CLOSE_DIALOG = "CLOSE_DIALOG";
export const OPEN_LOADING = "OPEN_LOADING";
export const CLOSE_LOADING = "CLOSE_LOADING";
export const OPEN_SNACKBAR_SUCCESS = "OPEN_SNACKBAR_SUCCESS";
export const OPEN_SNACKBAR_ERROR = "OPEN_SNACKBAR_ERROR";
export const CLOSE_SNACKBAR = "CLOSE_SNACKBAR";
